import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit{

  constructor(public common : CommonService) { }

  ngOnInit(): void {
    // this.common.showBackButton = false
  }

  
}
